import { BaseComponent } from './base.component';

export class PatientComponentBase extends BaseComponent {

    constructor() {
        super();
    }
}
